module.exports = __webpack_public_path__ + "img/colorBox1.2f88e92a.jpg";